import PropTypes from "prop-types";
import MatchedJobMessages from "../../../../MatchesPage/components/MessagesTab";

export default function ApplicationMessagesTab({ applicationDetails }) {
  return <MatchedJobMessages candidateId={applicationDetails?.candidateId}
    jobId={applicationDetails?.jobData?.jobId || applicationDetails?.jobData?.jobDetails?.jobId} />;
}

ApplicationMessagesTab.propTypes = { applicationDetails: PropTypes.object };
